const Footer = () => {
	return (
		<footer>
			<p>Not official timetable*</p>
		</footer>
	);
};

export default Footer;
